import {
  Component,
  EventEmitter,
  Output,
  Input,
  OnChanges,
} from "@angular/core";
import { AuthenticateService } from "src/app/shared/services/authenticate.service";
import { CognitoService } from "src/app/shared/services/cognito.service";
import { CropsService } from "src/app/shared/services/crops.service";

@Component({
  selector: "app-common-crop",
  templateUrl: "./common-crop.component.html",
  styleUrls: ["./common-crop.component.sass"],
})
export class CommonCropComponent implements OnChanges {
  @Output() cropChange: EventEmitter<any> = new EventEmitter();
  @Input() componentData;
  loading: boolean;
  showsearchdata: boolean = true;
  previousPage: number;
  skip: number;
  collectionSize: number;
  groupName: string;
  page = 1;
  cropDataArray: any = [];
  globalImgUrl: string;
  searchStr: string = "";

  constructor(
    private cropService: CropsService,
    private cognitoService: CognitoService,
    private authService: AuthenticateService
  ) { }

  ngOnChanges() {
    this.globalImgUrl = this.authService.s3url();
    this.cognitoService.getCurrentUserToken().then((res: any) => {
      this.groupName = res.attributes.family_name;
      console.log("@@Component data:", this.componentData);
      if (this.componentData) {
        this.getCropDataByCategory(0);
      } else {
        this.getAllCrop(0);
      }
    });
  }
  getAllCrop(skip) {
    console.log("@@Coming to getAllCrop");
    this.loading = true;
    this.cropDataArray = [];
    this.showsearchdata = true;
    var options = {
      group: this.groupName,
      // options: {
      limit: 20,
      // sortFields: { createTs: -1 },
      skip: skip,
      // },
    };
    console.log("cropData options == ", options);
    this.cropService.getCropData(options).then((data: any) => {
      console.log("cropData == ", data);
      if (data.length > 0) {
        this.cropDataArray = data;
        console.log("varietyarray", this.cropDataArray);
        this.loading = false;
      } else {
        this.loading = false;
      }
    });
    var count = { group: this.groupName };
    this.cropService.getCropscount(count).then((data: any) => {
      console.log("COUNT : ", data);
      if (data.length > 0) {
        this.collectionSize = data[0].size;
      }
    });
  }

  loadPage(pageNumber: number) {
    this.loading = true;
    console.log("page number ", pageNumber, this.previousPage);
    if (pageNumber !== this.previousPage) {
      this.skip = pageNumber * 20 - 20;
      this.previousPage = pageNumber;
      if (this.componentData) {
        this.getCropDataByCategory(this.skip);
      } else {
        this.getAllCrop(this.skip);
      }
    }
  }

  getCropDataByCategory(skip) {
    console.log("@@Coming to getCropDataByCategory");
    this.loading = true;
    this.cropDataArray = [];
    this.showsearchdata = true;
    var options = {
      group: this.groupName,
      categoryId: this.componentData.categoryId,
      // options: {
      limit: 20,
      // sortFields: { createTs: -1 },
      skip: skip,
      // },
    };
    console.log("cropData options == ", options);
    this.cropService.getCropByCategory(options).then((data: any) => {
      console.log("cropData == ", data);
      if (data.length > 0) {
        this.cropDataArray = data;
        console.log("varietyarray", this.cropDataArray);
        this.loading = false;
      } else {
        this.loading = false;
        this.cropDataArray = [];
      }
    });
    var count = {
      group: this.groupName,
      categoryId: this.componentData.categoryId,
    };
    console.log("COUNT obj: ", count);
    this.cropService.getCropscount(count).then((data: any) => {
      console.log("COUNT : ", data);
      if (data.length > 0) {
        this.collectionSize = data[0].size;
      }
    });
  }

  backToCategory() {
    this.cropChange.emit();
  }

  clickOnCropData(record) {
    this.cropChange.emit(record);
  }

  onImgError(event) {
    event.target.src = this.globalImgUrl + "agri_logo.png";
  }

  searchByName() {
    if (this.searchStr != "") {
      var obj = {
        group: this.groupName,
        field: "cropName",
        text: this.searchStr,
        tableName: "cropdata",
      };
      console.log("search obj : ", obj);
      this.cropService.getCropRegex(obj).then((data: any) => {
        console.log("searched", data);
        this.searchStr = "";
        this.cropDataArray = [];
        if (data.length > 0) {
          this.cropDataArray = data;
          this.showsearchdata = false;
          console.log("cropDataArray", this.cropDataArray);
        } else {
          this.showsearchdata = false;
        }
      });
    }
  }
}
